import { NavLink, useLocation } from 'react-router-dom';

function NavMenu({ competition }) {
  const location = useLocation();

  const links = [
    {
      name: 'Inbjudan',
      subHeader: 'Tävlingsinformation',
      path: 'details',
      icon: 'description',
    },
    {
      name: 'Anmälningar',
      subHeader: 'Hantera anmälningar',
      path: 'registrations',
      icon: 'group',
    },
    {
      name: 'Startlista',
      subHeader: 'Lista över tävlande',
      path: 'startlist',
      icon: 'format_list_numbered',
    },
    {
      name: 'Fordon',
      subHeader: 'Besikta och skapa fordon',
      path: 'vehicles',
      icon: 'directions_car',
    },
    {
      name: 'Anbud',
      subHeader: 'Hantera anbud',
      path: 'biddings',
      icon: 'confirmation_number',
    },
    {
      name: 'Resultat',
      subHeader: 'Ladda upp resultat',
      path: 'result',
      icon: 'leaderboard',
    },
    {
      name: 'Tillägg',
      subHeader: 'Ladda upp tillägg',
      path: 'amendment',
      icon: 'attach_file',
    },
    {
      name: 'Anslagstavla',
      subHeader: 'Ladda upp övriga dokument',
      path: 'board',
      icon: 'push_pin',
    },
  ];

  return (
    <div
      className='nav-menu bg-white d-md-flex flex-md-row justify-content-between rounded my-4 p-2 gap-1'
      style={{ '--bs-bg-opacity': '.8' }}
    >
      {links.map((link) => {
        let splitPathName = location.pathname.split('/');

        splitPathName[splitPathName.length - 1] = link.path;
        const navigationUrl = splitPathName.join('/');
        return (
          <NavLink
            key={link.name}
            className={`link d-flex flex-md-column align-items-center gap-1 p-2 rounded text-reset text-decoration-none`}
            role='button'
            to={navigationUrl}
            state={{ competition: competition }}
          >
            <span className='material-symbols-outlined'>{link.icon}</span>
            <span>{link.name}</span>
            <span
              className='d-none d-lg-block text-secondary text-break text-center'
              style={{ fontSize: '12px' }}
            >
              {link.subHeader}
            </span>
          </NavLink>
        );
      })}
    </div>
  );
}

export default NavMenu;
